class Navigation{

	constructor() {

		let header = document.querySelector('.header-main');
		let menuItems = document.querySelectorAll('.menu-item--lev1');

		header.addEventListener("mouseenter", () => {
			header.classList.add('header-main-hovered');
		});

		header.addEventListener("mouseleave", () => {
			header.classList.remove('header-main-hovered');
		});

		menuItems.forEach( (item) => {
			item.addEventListener( 'mouseenter', () => {
				if( item.classList.contains('menu-item-has-children') ){
					header.classList.add('header-subnav-open');
					item.classList.add('subnav-open');
				}
			});
			item.addEventListener( 'mouseleave', () => {
				header.classList.remove('header-subnav-open');
				item.classList.remove('subnav-open');
			});
		});

		ScrollTrigger.create({
			start: "top -100",
			end: 999999,
			toggleClass: {
				className: 'header-scrolled',
				targets: '.header-main'
			}
		});

	}

}